import { getFragmentData } from 'gql'
import { GetWorkspaceAmazonQuery, GetWorkspaceAmazonQueryVariables } from 'gql/graphql'

import { useQuery } from 'providers/tanstack-query/useQuery'
import { WORKSPACE_AMAZON_FRAGMENT_FOR_GET } from './api/fragment'
import { fromDTO } from './api/mapper'
import { GET_WORKSPACE_AMAZON } from './api/query'
import { Props, UseGetWorkspaceAmazon, WorkspaceAmazonSlice } from './types'

export const useGetWorkspaceAmazon = ({ workspaceId }: Props): UseGetWorkspaceAmazon => {
  const { data, isLoading } = useQuery<
    GetWorkspaceAmazonQueryVariables,
    GetWorkspaceAmazonQuery,
    null | WorkspaceAmazonSlice
  >({
    options: {
      enabled: workspaceId !== undefined,
      select: ({ workspaceAmazon }: GetWorkspaceAmazonQuery): null | WorkspaceAmazonSlice =>
        workspaceAmazon
          ? fromDTO(getFragmentData(WORKSPACE_AMAZON_FRAGMENT_FOR_GET, workspaceAmazon))
          : null,
    },
    query: GET_WORKSPACE_AMAZON,
    variables: { workspaceId },
  })

  return {
    loading: isLoading,
    workspaceAmazon: data,
  }
}
